export default (state) => {
    
    var TokenInStorage = localStorage.getItem('crowdbees');
    var Token          = state.auth.token;

    if(TokenInStorage)
    {
        Token = TokenInStorage;
    }

    return {
        auth : {
            token       : Token
            ,user       : state.auth.user
            ,fetching   : state.auth.fetching
            ,notif      : state.auth.notif
        }
        ,config : state.config
        ,initiative : state.initiative
    }
}